import React from 'react'
import { registerCarer } from '../../register-carer'
import { registerAuthorised } from '../../register-authorised'
import { registerEducator } from '../../register-educator'
import { RecordListActions } from '../../../../ui/gov-actions'

const GovPersonnelActions = ({ record }) => (
  <RecordListActions
    options={[registerCarer(record), registerAuthorised(record), registerEducator(record)]}
  />
)

export default GovPersonnelActions



// WEBPACK FOOTER //
// ./src/personnel/details/gov-personnel/views/gov-actions.jsx